(ns dre.components.search-results.views.footer
  (:require
   ["numeral" :as numeral]
   [dre.components.search-results.events :as-alias results]
   [dre.components.inputs :refer [input-number]]
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.i18n.views :refer [tr]]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]))


(def component-name :results-footer)

(defn pagination
  [{results-count :total
    items-offset :offset
    items-per-page :limit
    last-seen :last-seen}]
  [:<>
   [tr "Show "]
   [input-number
    {:max 100
     :min 10
     :step 5
     :size "small"
     :value items-per-page
     :on-change #(rf/dispatch-sync [::results/fetch {:limit (cond
                                                         (< % 10) 10
                                                         (> % 100) 100
                                                         :else %)} last-seen])}]
   [tr "/per page"]
   [:div
    {:class (bem/be component-name :pagination-controls)}
    [:button
     {:class (bem/bm :button [:light :bare :small
                              (when (<= items-offset 0) :disabled)])
      :on-click #(rf/dispatch-sync [::results/fetch {:offset (max 0 (- items-offset items-per-page))} last-seen])}
     [icoinor-icon :nav-arrow-left]]
    [tr "%s – %s of %s"
     (+ items-offset 1)
     (min (.format (numeral results-count) "0a") (+ items-offset items-per-page))
     (.format (numeral results-count) "0a")
     results-count]
    [:button
     {:class (bem/bm :button [:light :bare :small
                              (when (>= (+ items-offset items-per-page) results-count) :disabled)])
      :on-click #(rf/dispatch-sync [::results/fetch {:offset (+ items-offset items-per-page)} last-seen])}
     [icoinor-icon :nav-arrow-right]]]])

(defn view
  [state]
  [:div
   {:class component-name}
   [:div
    {:class (bem/be component-name :pagination)}
    [pagination state]]])
